import AuthResultDTO from 'models/dto/authResultDTO';
import { apiOutlookTaskExchangeAccessTokenForGraphToken } from 'services/Api/officeAddInService';

export const exchangeAccessTokenForGraphToken = async (token: string): Promise<AuthResultDTO> => {
  const result = await apiOutlookTaskExchangeAccessTokenForGraphToken(token);

  return result;
};
